/**
 * Breadcrumbs.jsx
 * Created by Destin Frasier on 7/24/17.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { truncate, uniqueId } from 'lodash';

const propTypes = {
    path: PropTypes.arrayOf(PropTypes.object).isRequired,
    maxLengthTitle: PropTypes.number
};

const defaultProps = {
    maxLengthTitle: 100
};

const generateItem = (item, maxLengthTitle) => {
    const title = truncate(item.title, { length: maxLengthTitle });
    if (item.url) {
        return (<a href={item.url} title={item.title}>{title}</a>);
    }
    return (<span title={item.title}>{title}</span>);
};

const Breadcrumbs = ({ path, maxLengthTitle }) => (
    <ul className="rec-breadcrumb">
        {path.map((item) => (
            <li key={`${uniqueId(item.title)}`}>{generateItem(item, maxLengthTitle)}</li>
        )
        )}
    </ul>
);

Breadcrumbs.propTypes = propTypes;
Breadcrumbs.defaultProps = defaultProps;

export default Breadcrumbs;
